(() => {
  document.querySelectorAll('[data-obp-charging]').forEach((root) => {
    const cards = [...root.querySelectorAll('[data-product-model]')];
    const modelCards = [...root.querySelectorAll('[data-model-card]')];
    const modelButtons = [...root.querySelectorAll('[data-model-filter]')];
    const status = root.querySelector('[data-filter-status]');
    const reset = root.querySelector('[data-filter-reset]');
    const productSection = root.querySelector('#produkte');
    const productGrid = root.querySelector('.obp-ca-products');

    const filterProducts = (model) => {
      cards.forEach((card) => {
        card.hidden = model !== 'all' && card.dataset.productModel !== model;
      });
      if (productGrid) productGrid.dataset.activeFilter = model;
      modelCards.forEach((card) => {
        card.classList.toggle('is-active', card.dataset.modelCard === model);
      });
      modelButtons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.modelFilter === model));
      });
      if (status) {
        status.textContent = model === 'all'
          ? 'Alle Produkte werden angezeigt.'
          : `Passendes Zubehör für Modell ${model} wird angezeigt.`;
      }
      if (reset) reset.hidden = model === 'all';
      if (productSection) {
        const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        productSection.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
    };

    modelButtons.forEach((button) => {
      button.addEventListener('click', () => filterProducts(button.dataset.modelFilter));
    });
    if (reset) reset.addEventListener('click', () => filterProducts('all'));

    root.querySelectorAll('.obp-ca-faq-wrap details').forEach((detail) => {
      detail.addEventListener('toggle', () => {
        const mark = detail.querySelector('summary span');
        if (mark) mark.textContent = detail.open ? '×' : '+';
      });
    });
  });
})();
